import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";



const PhpLesson18 = () => {
    const [language, changeLanguage] = useState("php");
    const [lineNumbers, toggleLineNumbers] = useState(false);
      const code = (
        'text',
        `
        // Creating an array without specifying keys
$colors = ['red', 'green', 'blue'];

// Creating an array with keys
$person = array('name' => 'John', 'age' => 30, 'city' => 'New York');


        `
      );

      const code1 = (
        'text',
        `
        // Adding elements to an array
        array_push($colors, 'yellow');

        // Removing elements from an array
        array_pop($colors);

        // Merging arrays
        $mergedArray = array_merge($colors, ['orange', 'purple']);


        `
      );
      const code2 = (
        'text',
        `
        // Using foreach loop to iterate through an array
        foreach ($person as $key => $value) {
            echo "Key: $key, Value: $value <br>";
        }


        `
      );
      const code3 = (
        'text',
        `
        // Sorting an array
        sort($colors); // Sorts array elements in ascending order


        `
      );
      const code4 = (
        'text',
        `
        // Accessing array elements
        echo $colors[0]; // Outputs the first element of the $colors array

        // Modifying array elements
        $person['age'] = 35;

        // Deleting array elements
        unset($person['city']);


        `
      );
      const code5 = (
        'text',
        `
        // Searching for a value in an array
        $position = array_search('green', $colors);

        // Checking if a key exists in an array
        if (array_key_exists('name', $person)) {
            echo "Key 'name' exists in the array.";
        }

        // Checking if a value exists in an array
        if (in_array('blue', $colors)) {
            echo "The value 'blue' exists in the array.";
        }

        // Slicing an array
        $subset = array_slice($colors, 1, 2); // Returns ['green', 'blue']

        `
      );







  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
      <h3><strong>Arrays in PHP</strong></h3>
      <p>Arrays in PHP are versatile data structures that can hold multiple values under a single variable name. They offer flexibility and convenience in storing and manipulating data. Below are some key aspects of arrays in PHP:</p>



      </div>

      <div className="alert alert-secondary" role="alert">
      <h4><strong>Syntax</strong></h4>
      <p> In PHP, arrays can be created using square brackets [] or the array() function. You can initialize an array with or without specifying keys.</p>

      <CopyBlock
                        language={"php"}
                        text={code}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />


      </div>


      <div className="alert alert-secondary" role="alert">
    <h4><strong>Functions</strong></h4>
    <p>PHP provides numerous built-in functions for working with arrays. These functions allow you to add elements, remove elements, merge arrays, and perform other operations.</p>

    <CopyBlock
                        language={"php"}
                        text={code1}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />

    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>Iterating</strong></h4>
    <p> You can iterate through arrays using loops such as foreach, for, or while to access and manipulate each element.</p>

    <CopyBlock
                        language={"php"}
                        text={code2}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />



    </div>



    <div className="alert alert-secondary" role="alert">
        <h4><strong>Sorting</strong></h4>
        <p>PHP offers functions like sort(), asort(), ksort(), etc., for sorting arrays based on different criteria.</p>

        <CopyBlock
        language={"php"}
        text={code3}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
      </div>

        <div className="alert alert-secondary" role="alert">
        <h4><strong>Accessing Elements</strong></h4>
        <p>You can access array elements using their keys or indexes, and also modify or delete elements as needed.</p>

        <CopyBlock
        language={"php"}
        text={code4}
        showLineNumbers={lineNumbers}
        theme={dracula}
        wrapLines={true}
        codeBlock
        />
        </div>


        <div className="alert alert-secondary" role="alert">
        <h4><strong>Array Operations</strong></h4>
        <p>PHP supports various operations on arrays, including searching for values, checking for the existence of keys or values, and slicing arrays to extract subsets of data.</p>

        <CopyBlock
                        language={"php"}
                        text={code5}
                        showLineNumbers={lineNumbers}
                        theme={dracula}
                        wrapLines={true}
                        codeBlock
                      />


    </div>




    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}
export default PhpLesson18
